// extracted by mini-css-extract-plugin
export default {"wrapper":"edit_thresholds_modal-module___wrapper___c8cee025","colorPicker":"edit_thresholds_modal-module___colorPicker___e0cb1c3d"};